import { useMemo } from 'react';
import { PaperProps } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { RemindingTone, useScheduledActionInvoiceQuery } from '../../../../api/gql';
import { RemindingToneInfoBox } from '../../../../components/RemindingToneInfoBox';

type Props = {
  taskId: string;
} & PaperProps;

export const TaskIdRemindingToneBox = ({ taskId, ...rest }: Props) => {
  const { t } = useTranslation();
  const { data, isLoading, isError } = useScheduledActionInvoiceQuery({
    id: taskId,
  });

  const remindingTone = useMemo(
    () => data?.scheduledAction.invoice.remindingTone ?? RemindingTone.Neutral,
    [data?.scheduledAction.invoice.remindingTone],
  );

  return (
    <RemindingToneInfoBox
      tone={remindingTone}
      isLoading={isLoading}
      errorMessage={isError ? (t('query.error.default') as string) : undefined}
      titleProps={{ variant: 'h2' }}
      showIcon={false}
      {...rest}
    />
  );
};
